'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroText = require('./NitroText');

var _NitroText2 = _interopRequireDefault(_NitroText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroText2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-text/index.js
// module id = 19
// module chunks = 4